module.exports = __webpack_public_path__ + "static/media/Barbarian.ebfc47cf.jpg";